module.exports = __webpack_public_path__ + "img/beachtennis.7972f3bd.svg";